export default "__VITE_ASSET__BHME8xKZ__"